import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { decamelizeKeys } from 'humps';
import { ApiRoutes } from '../api/ApiRoutes';
import { useAxios } from '../api/AxiosContext';
import { EstinationPayloadProps } from '../api/request';
import { EstimateResponseProps } from '../api/response';

export const useEstimateMutation = () => {
  const axios = useAxios();

  const handleEstimate = (payload: EstinationPayloadProps) => {
    return axios.post<AxiosResponse<EstimateResponseProps>>(ApiRoutes.estimateTrip, decamelizeKeys(payload));
  };

  return useMutation(handleEstimate, {
    cacheTime: 0,
    retry: 1,
  });
};
